<template>
  <b-container>
    <b-row>
      <b-col> </b-col>
    </b-row>
    <div class="application-view">
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="12">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Personal Details</h5>
                  <table class="profile-table table-3x" style="margin-left: 0">
                    <tbody>
                      <tr>
                        <td colspan="3">
                          <span class="bold">Applicant Name:</span>
                          {{ personalDetails.FirstName }}
                          {{ personalDetails.MiddleName }}
                          {{ personalDetails.LastName }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Date Of Birth:</span>
                          {{ personalDetails.DOB }}
                        </td>
                        <td>
                          <span class="bold">Aadhar Id:</span>
                          {{ personalDetails.AdharNo }}
                        </td>
                        <td>
                          <span class="bold">PAN No.:</span>
                          {{ personalDetails.PanCardNo }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Gender:</span>
                          <span v-if="personalDetails.Gender">Male</span>
                          <span v-else>Female</span>
                        </td>
                        <td>
                          <span class="bold">Email:</span>
                          {{ personalDetails.EmailID }}
                        </td>
                        <td>
                          <span class="bold">Mobile No.:</span>
                          {{ personalDetails.MobileNo }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>
    <div class="application-view">
      <b-row>
        <b-col md="6">
          <b-form @submit="onSubmit" @reset="onReset">
            <div class="form-row">
              <b-col class="py-0">
                <b-form-group
                  id="grpDocType"
                  label-cols="2"
                  label="Document Type"
                  label-size="sm"
                  label-for="ipDocType"
                >
                  <b-select
                    id="ipDocType"
                    class="form-control"
                    value-field="DocumentTypeID"
                    size="sm"
                    text-field="DocumentType"
                    :options="DocTypes"
                    v-model="form.DocumentID"
                    @change.native="getLog"
                  ></b-select>
                </b-form-group>
              </b-col>
            </div>
            <div class="form-row"  v-if="RoleType == 1">
              <b-col class="py-0">
                <b-form-group
                  id="grpFile"
                  label-cols="2"
                  label="Select File"
                  label-size="sm"
                  label-for="ipfi1"
                >
                  <b-form-file
                    ref="fi1"
                    id="ipfi1"
                    @change="filechange($event)"
                    accept=".jpg, .png, .gif, .pdf"
                    size="sm"
                  ></b-form-file>
                </b-form-group>
                <b-progress
                  height="10px"
                  :value="progressval"
                  v-if="isFileLoading"
                ></b-progress>
                <div class="col-md-4" v-if="form.NewPath != ''">
                  <a :href="getImgUrl2(form.NewPath)" target="_blank">
                    <img
                      :src="getImgUrl(form.NewPath)"
                      width="30px"
                      class="img-fluid"
                    />
                  </a>
                </div>
              </b-col>
            </div>
            <div class="form-row"  v-if="RoleType == 1">
              <b-col class="py-0 my-0">
                <b-form-group
                  id="grpRemarks"
                  label-cols="2"
                  label="Remarks"
                  label-size="sm"
                  label-for="ipRmk"
                >
                  <b-form-textarea
                    id="ipRemarks"
                    v-model="form.Remarks"
                    size="sm"
                    rows="2,"
                    max-rows="4"
                    placeholder="Remarks"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </div>
            <div class="form-row">
              <b-col class="md-6">
                <b-button type="submit" class="float-right" variant="primary" v-if="RoleType == 1"
                  >Submit</b-button
                >
                <b-button type="reset" class="float-right mx-3" variant="danger"  v-if="RoleType == 1"
                  >Reset</b-button
                >
              </b-col>
            </div>
            <div class="form-row">
              <b-col>
                <Spinner
                  size="32"
                  message="Loading..."
                  v-if="isLoading"
                ></Spinner>
                <b-alert
                  :show="showDismissibleAlert"
                  dismissible
                  @dismissed="showDismissibleAlert = false"
                  :variant="variant"
                  >{{ alertText }}</b-alert
                >
              </b-col>
            </div>
          </b-form>
        </b-col>
        <b-col md="6">
          <b-table
            striped
            hover
            :items="logTbl"
            :fields="fields"
            head-variant="dark"
            style="font-size: 12px"
          >
            <template v-slot:cell(OldPath)="row">
              <a target="_blank" :href="getImgUrl2(row.item.OldPath)">View</a>
            </template>
            <template v-slot:cell(NewPath)="row">
              <a target="_blank" :href="getImgUrl2(row.item.NewPath)">View</a>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>
<script>
import apis from "@/apis";
import DatePicker from "vue2-datepicker";
import Spinner from "vue-simple-spinner";
import Formatter from "@/Formatter.js";
import lambda from "@/apis/lambda";
import axios from "axios";

export default {
  components: { Spinner, DatePicker },
  props: ["UserID", "Stage", "Id", "OldPath"],

  data() {
    return {
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      logTbl: [],
      fields: [
        { key: "OldPath", label: "Old Doc" },
        { key: "NewPath", label: "New Doc" },
        { key: "ChangeDate", label: "Date", sortable: true },
        { key: "Remarks", label: "Remarks" },
      ],
      form: {
        UserID: "00000000-0000-0000-0000-000000000000",
        ApplicationID: "00000000-0000-0000-0000-000000000000",
        DocumentID: 1,
        OldPath: "",
        NewPath: "",
        Remarks: "",
        DocStage: 2,
      },
      isFileLoading: false,
      progressval: 0,
      DocTypes: [],
      personalDetails: {
        UserID: null,
        Salutation: null,
        FullName: null,
        FirstName: "",
        MiddleName: "",
        LastName: "",
        DOB: null,
        Age: 38,
        Gender: true,
        MobileNo: null,
        EmailID: "",
        AdharNo: "",
        PanCardNo: "",
      },

      UserDocuments: {
        PhotoPath: null,
        SignaturePath: null,
        AddharCardPath: null,
        PancardPath: null,
        RationCardPath: null,
        CasteCertificate: null,
        EduCertificate: null,
        ExServiceManProof: null,
        ExprienceCertificate: null,
        BirthCertificate: null,
        PoliceVerification: null,
        MedicalCertificate: null,
        RecommendationLetter: null,
        DeceasedID: null,
        LegalHireNOC: null,
        FinalDuesLetter: null,
        CourtOrder: null,
      },
    };
  },
  computed: {
    RoleType() {
      var userinfo = this.$store.getters.loggedUser;
      return userinfo.RoleID;
    },
  },
  methods: {
    goback() {
      //this.$router.back();
      this.$router.push({
        name: "Applications",
        params: {
          userDistrictID: this.$store.getters.getUserDistrict,
          userApprovalStatus: this.$store.getters.getAppStatus,
          userLoanType: 1,
        },
      });
    },
    getLog(evt) {
      let id = evt.target.value;
      this.fnGetLog(id);
    },
    fnGetLog(id) {
      let promiseL = apis.ReadDocumentChangeLog(this.form.ApplicationID, id);

      promiseL.then((response) => {
        if (response.status == 200) {
          this.logTbl = response.body;
        }
      });
    },
    filechange(evt) {
      evt.preventDefault();
      if(this.RoleType != 1)
      {
        alert("Only Admin can change the files");
        return;
      }
      this.progressval = 0;

      this.isFileLoading = true;

      if (!evt.target.files || evt.target.files.length == 0) return;

      var strings = evt.target.files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        alert("Wrong File Input");
        this.$refs[evt.target.id].reset();
        this.isFileLoading = false;
        this.progressval = 0;
        return;
      }

      var filetype = evt.target.files[0].type;
      var filepath = evt.target.files[0].name
        .replace("." + extn, Date.now() + "." + extn)
        .replace(/ /g, "_");

      var userid = this.UserID;

      let promise = lambda.getSignedURL(userid, filepath, filetype);

      promise
        .then((response) => {
          let signedUrl = response;

          let x = this;
          var options = {
            onUploadProgress: function (progressEvent) {
              x.progressval = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            },
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": filetype,
            },
          };
          return axios.put(signedUrl, evt.target.files[0], options);
        })
        .then((res) => {
          //console.log("Response", res);
          //alert(this.dismissSecs);
          if (res.status == 200) {
            this.form.NewPath = filepath;
            //alert("File Uploaded Successfully");
          } else {
            alert("Error in uploading file");
            this.$refs[evt.target.id].reset();
          }
          this.isFileLoading = false;
        })
        .catch((err) => {
          console.error(err);
          alert("Error");
          //this.$refs[evt.target.id].reset();
          this.isFileLoading = false;
          this.progressval = 0;
        });
    },
    getImgUrl(pic) {
      if (pic) {
        if (pic.split(".").pop() == "pdf") {
          return require("@/assets/Pdf.jpg");
        }

        var userid = this.UserID;
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic
        );
      }
    },
    getImgUrl2(pic) {
      if (pic) {
        var userid = this.UserID;
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic
        );
      }
    },
    onSubmit(evt) {
      evt.preventDefault();
      if(this.RoleType != 1)
      {
        alert("Only Admin can change the files");
        return;
      }
      let promiseS = apis.SaveDocumentChangeLog(this.form);
      promiseS
        .then((response) => {
          if (response.status == 200) {
            this.logTbl = response.body;
            this.alertText = "File Changed Successfully";
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.onReset(evt);
          }
        })
        .catch((err) => {
          this.alertText = err;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    onReset(evt) {
      evt.preventDefault();
      this.form.DocumentID = 0;
      this.form.OldPath = "";
      this.form.NewPath = "";
      this.form.Remarks = "";
      this.$refs["fi1"].reset();
    },
  },
  mounted() {
    this.form.DocStage = this.Stage;
    this.form.OldPath = this.OldPath || "";
    if (this.Stage == "2") {
      this.DocTypes.push({
        DocumentTypeID: 1,
        DocumentType: "Sanction Letter",
      });
    } else if (this.Stage == "3") {
      this.DocTypes.push({
        DocumentTypeID: 1,
        DocumentType: "Disbursement Letter",
      });
      this.DocTypes.push({ DocumentTypeID: 2, DocumentType: "EMI Schedule" });
    } else if (this.Stage == "4") {
      this.DocTypes.push({
        DocumentTypeID: 1,
        DocumentType: "Claiim Paid Proof",
      });
      this.DocTypes.push({ DocumentTypeID: 2, DocumentType: "Business Photo" });
    }

    var userinfo = this.$store.getters.loggedUser;
    this.form.UserID = userinfo.UserId;
    this.form.ApplicationID = this.Id; //Id of Sanction Letter, Disbursement or Claim

    this.fnGetLog(1);
    let promiseU = apis.ReadUserDetailByIndivisual(this.UserID); //Personal Details

    promiseU
      .then((response) => {
        if (response.status == 200) {
          //console.log(response.body);
          this.personalDetails = response.body;
          this.personalDetails.DOB = Formatter.convertDateFormat(
            response.body.DOB
          );
          this.DOB = Formatter.convertDateFormatYMD(response.body.DOB);

          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch((err) => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  },
};
</script>
<style scoped>
table {
  font-family: arial, sans-serif;
  /* border-collapse: collapse; */
  width: 80%;
  margin-left: 10%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 6px;
}
.newfont {
  font-size: 0.875rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ClaimApproval/DocumentUpload.vue